import { validatePermission } from '../../../../containers/authorization-helpers/validate-permission';
import { AnyTransportationReport, AnyProductionReport, AnyAccountingReport } from '../../../../models/enums/permission-groups';
import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import { NavRibbon, NavRibbonLink } from '../../../../components/nav-ribbon/NavRibbon';
import { PageContent } from '../../../../components/page-components/PageContent';
import { IApplicationState } from '../../../../store/IApplicationState';
import { PageNames, Routes } from '../../../../utils/app-constants';
import "../../../../modules/reports/styles.scss";
import { AccountingReportsScene } from './AccountingReports';
import { ProductionReportsScene } from './ProductionReports';
import { TransportationReportsScene } from './TransportationReports';

interface IProps {
    currentPermissions: Permissions[];
}

/**
 * The reports page opens on the first of its parts the user can see: Transportation, then Production, then Accounting.
 * With none of them (or before what they hold is known) it is Transportation, which says what is wanted when the page
 * is forbidden.
 */
export const firstReportsPath = (held: Permissions[] | undefined): string => {
    const parts: Array<{ path: string; permissions: Permissions[] }> = [
        { path: 'transportation', permissions: AnyTransportationReport },
        { path: 'production', permissions: AnyProductionReport },
        { path: 'accounting', permissions: AnyAccountingReport }
    ];

    const first = parts.find(part => validatePermission({
        currentPermissions: held || [], requiredPermissions: part.permissions
    }));

    return `${ Routes.REPORTS_REPORTS }/${ first ? first.path : 'transportation' }`;
};

export class ReportsSceneComponent extends React.Component<IProps> {

    public render() {

        return <PageContent pageName={PageNames.REPORTS_MAIN}>
                    <NavRibbon links={[
                        new NavRibbonLink(
                            `${ Routes.REPORTS_REPORTS }/transportation`, 
                            'la-truck',
                            'Transportation',
                            [...AnyTransportationReport]
                        ),
                        new NavRibbonLink(
                            `${ Routes.REPORTS_REPORTS }/production`, 
                            'la-legal',
                            'Production',
                            [...AnyProductionReport]
                        ),
                        new NavRibbonLink(
                            `${ Routes.REPORTS_REPORTS }/accounting`, 
                            'la-money',
                            'Accounting',
                            [...AnyAccountingReport]
                        )
                    ]} />

                    <Switch>

                        <Route
                            key="reports-transportation"
                            exact={true}
                            path={`${ Routes.REPORTS_REPORTS }/transportation`}
                            render={() => <TransportationReportsScene />}
                        />

                        <Route
                            key="reports-production"
                            exact={true}
                            path={`${ Routes.REPORTS_REPORTS }/production`}
                            render={() => <ProductionReportsScene />}
                        />

                        <Route
                            key="reports-accounting"
                            exact={true}
                            path={`${ Routes.REPORTS_REPORTS }/accounting`}
                            render={() => <AccountingReportsScene />}
                        />

                        <Redirect
                            key="reports-redirect"
                            exact={true}
                            from={ Routes.REPORTS_REPORTS }
                            to={ firstReportsPath(this.props.currentPermissions) } />

                    </Switch>

                </PageContent>;
    }   
}

const mapStateToProps = (extendState = {}) => (state: IApplicationState) => {
    return {
        currentPermissions: state.userdata.user.permissions,
        ...extendState
    };
};

const ReportsScene = connect(
    mapStateToProps,
    null
)(ReportsSceneComponent);

export { ReportsScene };
